window.Survey = Block.extend({

    initialize: function(app, data, $dom, xml, junctionData, junctionController) {
        Block.prototype.initialize.call(this, app, data, $dom, xml, junctionData, junctionController);

        this.junctionData = junctionData;
        this.junctionController = junctionController;

        if(!this.junctionData) {
            Logger.error("Survey.getData", "survey must be in a junction.");
        }
    },

    render: function() {
        if(this.junctionData.getStatus() >= Status.COMPLETED) { // Don't render if junction complete
            this.continue();
        }

        var content = this.getContent(this.data);
        this.$el.html(content);

        this.setupButtons();

        OverviewAnimation.animateIn(this.$el.find(".overview"));
    },

    setupButtons: function() {
        var skipButton = new Button({
            el: this.$el.find(".continue-button")
        });
        this.listenTo(skipButton, "onClick", this.handleSkipClicked);
    },

    handleSkipClicked: function() {
        this.junctionData.setStatus(Status.COMPLETED); // complete junction
        this.continue();
    },

    continue: function() {
        this.complete();
        this.trigger("onSurveyComplete", {target: this});
        this.app.router.next();
    },

    getContent: function(data) {
        return Handlebars.templates["survey/survey"](data);
    },

    getData: function($xml, language) {
        var data = {};
        data.title = this.blockData.title();
        data.questions = [];

        var totalQuestions = this.junctionData.getTotalModules();
        for(var i = 0; i < totalQuestions; i++) {
            var module = this.junctionData.getModule(i);
            data.questions.push({
                id: module.getPage(0).pageID(),
                title: module.getModuleTitle(),
                isComplete: module.getModuleStatus() >= Status.COMPLETED
            });
        }

        data.continueLabel = LanguageManager.getString("skip_survey");

        return data;
    },
});
